/**
 * Salary stats API returns 404 when a location has no aggregated salary data.
 * That is expected for many SRP locations and must not be treated as an error.
 */
export function isNoSalaryStatsAvailableResponse(
  status: number,
  errorText: string,
): boolean {
  if (status !== 404) return false;
  return errorText.includes('No salary statistics available');
}
